<template>
<div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>
    <v-app id="inspire" light>
        <v-card color="grey lighten-5" flat>
            <v-layout row wrap>
                <v-flex xs12 md12 sm12>
                    <v-toolbar size="120px" dark color="info">
                        <v-toolbar-title> {{$t('Booking-List')}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-text-field flat="" solo-inverted="" hide-details v-model="searchara" :label="$t('Search')" append-icon="search">
                        </v-text-field>
            

                        <v-menu bottom origin="center center" transition="scale-transition">
                            <v-btn slot="activator" flat> <span class="hidden-sm-and-down"> {{ $t('Add') }}
                                </span>
                                <v-icon right dark>add_box</v-icon>
                            </v-btn>
                            <v-list>
                                <v-list>
                                    <a target="_self" v-bind:href="'#/coper/rezervasyon/index/id?islem=yeni'">
                                        <v-list-tile>
                                            <v-list-tile-title>{{$t('Add-Reservation')}}</v-list-tile-title>
                                        </v-list-tile>
                                    </a>
                                </v-list>
                                <v-list>
                                    <a target="_self" v-bind:href="'#/coper/vize/yeni/id?islem=yeni'">
                                        <v-list-tile>
                                            <v-list-tile-title>{{ $t('Add-v2', { value: $t('Visa')}) }}   </v-list-tile-title>
                                        </v-list-tile>
                                    </a>
                                </v-list>

                            </v-list>
                        </v-menu>

                    </v-toolbar>
                </v-flex>

                <v-container fluid>
                    <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
                        <v-layout row wrap>
                            <v-flex pb-3 xs12 sm12 md12>
                                <v-card flat>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm6 pt-2 md2>
                                            <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false" :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="Rapor.KayitTarihiBasla" v-model="Rapor.KayitTarihiBasla"></tarihcomp>
                                        </v-flex>

                                        <v-flex xs12 pt-2 sm6 md2>
                                            <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false" :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="Rapor.KayitTarihiBitis" v-model="Rapor.KayitTarihiBitis"></tarihcomp>
                                        </v-flex>

                                        <v-flex xs12 pt-2 sm6 md2>
                                            <v-select hide-details :items="doviztipi" v-model="Rapor.ParaBirimi" :rules="[v => !!v || $t('Mandatory-section')]" item-text="Title" item-value="DovizKod" :label="$t('Currency-Unit')"></v-select>
                                        </v-flex>
                                        <v-flex pt-2>
                                            <v-layout>
                                                <div v-if="load1">
                                                    <v-btn color="info" @click="getList()" fab small dark>
                                                        <v-icon>search</v-icon>
                                                    </v-btn>
                                                </div>
                                                <div v-if="progress">
                                                    <v-layout pt-3 align-center>
                                                        <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                                                    </v-layout>
                                                </div>
                                                <v-badge color="white" :overlap="true">
                                                    <template v-slot:badge>
                                                        <v-icon v-if="filtrevarmi" large color="green">check_circle_outline</v-icon>
                                                    </template>

                                                    <v-btn small @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()" color="info" fab dark>
                                                        <v-icon>filter_list</v-icon>
                                                    </v-btn>
                                                    <v-tooltip bottom :activator="el" v-model="tooltip">
                                                        <span>{{$t('Add-Search-Filter')}}</span>
                                                    </v-tooltip>
                                                </v-badge>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </v-flex>

                            <v-flex xs12 sm12 md12 pb-3>
                                <v-card flat class="white--text">
                                    <v-card flat>
                                        <v-card-actions>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12>
                                                    <v-card flat>
                                                        <v-data-table :headers="headerssatis" :rows-per-page-items="[20,100]" :items="itemssatis" :search="searchara">
                                                            <template slot="items" slot-scope="props">
                                                                <tr item>
                                                                    <!-- <td class="text-xs-left">{{ props.item.SiraNo }}</td> -->
                                                                    <td class="text-xs-left">{{ props.item.PNR_No }}</td>
                                                                    <td class="text-xs-left">{{ props.item.RezzKod }}</td>
                                                                    <td class="text-xs-left">{{ props.item.SaticiTip}}</td>
                                                                    <td class="text-xs-left">{{ props.item.CariKod }}</td>
                                                                    <td class="text-xs-left">{{ props.item.Unvan }}</td>
                                                                    <td class="text-xs-left">{{ props.item.Isim }}</td>
                                                                    <td class="text-xs-right">{{ props.item.SatisTL | moneyformat }}</td>
                                                                    <td class="text-xs-right">{{ props.item.AlisTL | moneyformat }}</td>
                                                                    <td class="text-xs-right">{{ props.item.KomisyonTL | moneyformat }}</td>
                                                                    <td class="text-xs-right">{{ props.item.BakiyeTL | moneyformat }}</td>
                                                                    <td class="text-xs-left">{{ props.item.FaturaNo }}</td>
                                                                    <!-- <td class="text-xs-left">{{ props.item.RezYapan }}</td>
                                    <td class="text-xs-left">{{ props.item.RezzKod }}</td>
                                    <td class="text-xs-left">{{ props.item.MasrafMerkezi }}</td>
                                    <td class="text-xs-left">{{ props.item.TurOperator }}</td> -->
                                                                    <td class="justify-start align-center full-heigth layout px-0">
                                                                        <!-- <v-tooltip bottom>
                                        <v-btn icon small slot="activator" flat @click="pnrIptalDialog(props.item)">
                                          <v-icon color="red">cancel</v-icon>
                                        </v-btn>
                                        <span>PNR İptal</span>
                                      </v-tooltip> -->
                                                                        <v-btn icon small slot="activator" flat @click="git(props.item)">
                                                                            <v-icon color="info">search</v-icon>
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                                                {{ $t('No-records-searched-for', { value: searchara}) }}
                                                            </v-alert>
                                                        </v-data-table>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-container>

                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                    {{ text1 }}
                    <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
                </v-snackbar>

                <v-dialog v-model="dialogfiltre" scrollable persistent max-width="400px">
                    <v-card flat color="grey lighten-4">
                        <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md12 pa-1>
                                    <v-card flat class="white--text">
                                        <v-card flat color="grey lighten-5">
                                            <v-card-actions>

                                                <v-layout row wrap>
                                                    <v-flex md12 xs12 sm12>
                                                        <pnrbul v-model="Rapor.Prm.PPNR_No" hide-details>
                                                        </pnrbul>
                                                    </v-flex>

                                                    <v-flex md12 xs12 sm12>
                                                        <cariaracomp v-bind:etiket="$t('Currentcode_label')" v-bind:value="Rapor.Prm.PCariKod" v-model="Rapor.Prm.PCariKod" :Coper="true"></cariaracomp>
                                                    </v-flex>

                                                    <v-flex md12 xs12 sm12>
                                                     <takipno v-model="Rapor.TakipNo" hide-details> </takipno>
                                                    </v-flex>

                                                    <v-flex md12 xs12 sm12>
                                                        <cariaracomp v-bind:etiket="$t('Current-Main-Account')" v-bind:value="Rapor.Prm.PCariAnaHesap" v-model="Rapor.Prm.PCariAnaHesap" :Coper="true"></cariaracomp>
                                                    </v-flex>

                                                    <v-flex md6 xs12 sm6>
                                                        <v-select clearable :items="itemssaticitip" item-text="Aciklama" item-value="Kod" v-model="Rapor.Prm.PSaticiTip" :label="$t('Seller-Type')" hide-details="">
                                                        </v-select>
                                                    </v-flex>

                                                    <v-flex xs12 sm6 md6>
                                                        <genelarama :autofocuss="true" apiname="SaticiAra" :tip="Rapor.Prm.PSaticiTip" :label="$t('Seller-Code')" v-model="Rapor.Prm.PSaticiKod"></genelarama>

                                                    </v-flex>

                                                    <v-flex pl-1 xs12 sm12 md12>
                                                        <genelarama apiname="MasrafMerkeziAra" :label="$t('Expense-Center-v2')" v-model="Rapor.Prm.PMasrafMerkezi"></genelarama>
                                                    </v-flex>

                                                    <v-flex xs12 sm12 md12>
                                                        <referansmerkezicomp :coper="true" v-model="Rapor.Prm.PReferans" :etiket="$t('Reference-Centre')">
                                                        </referansmerkezicomp>
                                                    </v-flex>

                                                    <v-flex xs12 sm12 md12>
                                                        <genelarama apiname="SaticiAra" :tip="12" label="Tur Operatörü" v-model="Rapor.Prm.PTurOp">
                                                        </genelarama>
                                                    </v-flex>

                                                    <v-flex md12 xs12 sm12>
                                                        <v-select :items="itemsicdis" item-text="text" item-value="value" v-model="Rapor.Prm.PSaticiIc_Dis" label="İç Dış" hide-details="">
                                                        </v-select>
                                                    </v-flex>

                                                    <v-flex md12 xs12 sm12>
                                                        <v-select :items="itemsopsiyon" item-text="text" item-value="value" v-model="Rapor.Prm.POpsiyon" :label="$t('Optional-Sales')" hide-details="">
                                                        </v-select>
                                                    </v-flex>

                                                    <v-flex md12 xs12 sm12>
                                                        <anatip v-model="Rapor.Prm.PAnaTip"></anatip>
                                                    </v-flex>
               
                                                    <v-flex xs12 sm12 md12>

                                                        <v-text-field hide-details v-model="Rapor.Prm.PCariHesapGrubu" :label="$t('Account-Group')">
                                                        </v-text-field>

                                                    </v-flex>

                                                    <v-flex xs12 sm12 md12>

                                                        <v-text-field hide-details v-model="Rapor.Prm.PSaticiGrup" :label="$t('Seller-Group')">
                                                        </v-text-field>

                                                    </v-flex>

                                                    <v-flex xs12 sm12 md12>

                                                        <v-text-field hide-details v-model="Rapor.Prm.PSatisFaturaNo" :label="$t('Invoice-No')">
                                                        </v-text-field>

                                                    </v-flex>

                                                    <v-flex xs12 sm12 md12>
                                                        <v-select hide-details :items="itemskomisyon" v-model="Rapor.Prm.PKomisyonFaturali" item-text="text" item-value="value" :label="$t('Commission-Invoice')"></v-select>
                                                    </v-flex>

                                                </v-layout>
                                            </v-card-actions>
                                        </v-card>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                            <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-if="iptalDialog" v-model="iptalDialog" max-width="450px">
                    <v-card>
                        <v-card-text>
                            <v-container>

                                <v-form ref="formiptal" v-model="valid" lazy-validation>
                                    <v-layout class="  project overdue" row wrap>
                                        <v-flex xs12 pb-2 sm12 md12>
                                            <v-layout row wrap>

                                                <v-toolbar flat="" size="120px" dark color="white">
                                                    <v-toolbar-title> <span class="subheading black--text">
                                                            {{ $t('Details-of-PNR-Cancelled') }}
                                                        </span> </v-toolbar-title>
                                                    <v-spacer></v-spacer>
                                                </v-toolbar>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex pl-4 xs3 md3 sm3>
                                            <span> {{ $t('PNR-No') }} </span>
                                        </v-flex>
                                        <v-flex xs9 md9 sm9>
                                            <span>:{{secilenKayit.PNR_No}} </span>
                                        </v-flex>
                                        <v-flex xs3 pl-4 md3 sm3>
                                            <span> {{ $t('Current') }} </span>
                                        </v-flex>
                                        <v-flex xs9 md9 sm9>
                                            <span>:{{secilenKayit.CariKod}}-{{secilenKayit.Unvan}} </span>
                                        </v-flex>

                                    </v-layout>
                                    <v-flex pl-4 pt-2 xs12 md12 sm12>
                                        <v-text-field hide-details :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="IptalNedeni" :label="$t('Reason-of-Cancellation')"></v-text-field>
                                    </v-flex>
                                </v-form>

                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="info" flat="flat" @click.native="iptalDialog = false">{{$t("cancel_button")}}</v-btn>
                            <v-btn color="info" flat @click.native="pnrIptal()">{{ $t('OK') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

            </v-layout>
        </v-card>
    </v-app>
</div>
</template>

<script>
import auth from "../../../api/auth";
import tarihcomp from "../customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../coper/tools";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import anatip from "@/components/app/coper/comp/anatip.vue";
import rez from "./rezervasyon";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
import takipno from '@/components/app/coper/component/takipno.vue'

export default {
    data() {
        return {

            itemskomisyon: [{
                text: this.$t('None'),
                value: false
            }, {
                text: this.$t('Available'),
                value: true
            }, {
                text: this.$t('All-v2'),
                value: null
            }],
            itemssaticitip: rez.SaticiTip,
            itemsicdis: rez.IcDis,
            itemsopsiyon: rez.Opsiyon,
            searchara: null,
            IptalNedeni: null,
            iptalDialog: false,
            secilenKayit: {},
            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0
            },
            filtrevarmi: false,
            search: "",
            searchsatilanbilet: null,
            searchiadebilet: null,
            searchvoid: null,

            headerssatis: [

                {
                    text: this.$t('PNR-No'),
                    value: "PNR_No",
                    width: "5%",
                    align: "left"
                },
                {
                    text: "Rez. Kod",
                    value: "RezzKod",
                    width: "5%",
                    align: "left"
                },
                {
                    text: "Satıcı Tip",
                    value: "SaticiTip",
                    width: "10%",
                    align: "left"
                },
                {
                    text: this.$t('Currentcode_label'),
                    value: "CariKod",
                    width: "10%",
                    align: "left"
                },
                {
                    text: this.$t('Title_label'),
                    value: "Unvan",
                    width: "10%",
                    align: "left"
                },
                {
                    text: this.$t('Name'),
                    value: "Isim",
                    width: "10%",
                    align: "left"
                },
                {
                    text: this.$t('Sales'),
                    value: "SatisTL",
                    width: "10%",
                    align: "left"
                },
                {
                    text: "Alış",
                    value: "AlisTL",
                    width: "10%",
                    align: "left"
                },
                {
                    text: "Komisyon",
                    value: "KomisyonTL",
                    width: "10%",
                    align: "left"
                },
                {
                    text: this.$t('Balance'),
                    value: "BakiyeTL",
                    width: "10%",
                    align: "left"
                },
                {
                    text: this.$t('Invoice-No'),
                    value: "FaturaNo",
                    width: "10%",
                    align: "left"
                },
                // {
                //   text: "Rez Sorumlusu",
                //   value: "RezYapan",
                //   width: "10%",
                //   align: "left"
                // },
                // {
                //   text: "Karşı Rez. Kod",
                //   value: "RezzKod",
                //   width: "10%",
                //   align: "left"
                // },

                // {
                //   text: "Masraf Merkezi",
                //   value: "MasrafMerkezi",
                //   width: "10%",
                //   align: "left"
                // },
                // {
                //   text: "Tur Operatörü",
                //   value: "TurOperator",
                //   width: "10%",
                //   align: "left"
                // },
                {
                    text: "",
                    value: "",
                    sortable: false

                },
            ],

            Rapor: {
                KayitTarihiBasla: null,
                KayitTarihiBitis: null,
                ParaBirimi: "TL",
                TakipNo: null,
                Prm: {
                    PCariKod: null,
                    PPNR_No: null,
                    PSirketNo: null,
                    PCariSirket: null,
                    PPNR_ParaBirimi: null,
                    PKayitTarihBas: null,
                    PKayitTarihBit: null,
                    PDonem1Bas: null,
                    PDonem1Bit: null,
                    PDonem2Bas: null,
                    PDonem2Bit: null,
                    PFatTarihBas: null,
                    PFatTarihBit: null,
                    PKomFatTarihBas: null,
                    PKomFatTarihBit: null,
                    PSaticiTip: null,
                    PSaticiKod: null,
                    PDosyaTip: null,
                    PDosya: null,
                    PAcente: null,
                    PPNRBir: null,
                    PCariHesapGrubu: null,
                    PCariTip: null,
                    PSaticiGrup: null,
                    PSaticiIc_Dis: null,
                    PTurOp: null,
                    PFaturali: null,
                    POpsiyon: null,
                    PAnaTip: null,
                    PCariAnaHesap: null,
                    PIptalRaporu: null,
                    PRezGrupID: null,
                    PSatisGrubu: null,
                    PSatisGrupTip: null,
                    PSaticiOdemesiHesapla: null,
                    PMasrafMerkezi: null,
                    PAcenteDepartmanID: null,
                    PPozisyonNo: null,
                    PSatisFaturaNo: null,
                    PMusteriOdemelilerHaric: null,
                    PReferans: null,
                    PSatisTip1: null,
                    PSatisTip2: null,
                    PSatisTip3: null,
                    PSatisTip4: null,
                    PGelenFatTarihBas: null,
                    PGelenFatTarihBit: null,
                    PProfilSablonId: null,
                    PKomisyonFaturali: null,
                    PGelenFaturali: null,
                }
            },

            TurOperatoru: {
                id: null,
                kod: null,
                isim: null,
                tip: 0
            },
            itemsairlinelist: [],
            hesapgurubu: [],
            masrafmerkezi: [],
            doviztipi: [],
            valid: true,
            tumsirketler: "",
            totalCount: 0,
            totalService: 0,
            totalAmount: 0,
            StartDate: null,
            EndDate: null,
            date: null,
            menu: false,
            modal: false,
            dateFormatted: "",
            date2: null,
            menu2: false,
            dateFormatted2: "",
            modal2: false,
            loading: false,
            items: [],
            load: false,
            load1: true,
            search3: "",

            renk1: "info",
            dialogfiltre: false,
            hesapkodu: [],
            kredikarti: [],
            statecari: [],
            searchcari: "",
            progress: false,
            tooltip: false,
            el: null,
            yok: false,
            itemssatis: [],
            itemsiade: [],
            itemsvoid: [],

            butondurum: true,
            snackbar: false,
            y: "top",
            x: "right",
            mode: "",
            timeout: 6000,
            text1: "",
            dictionary: {
                custom: {
                    tarihsec: {
                        required: () => this.$t('Please-choose-a-date')
                    },
                    tarihsec1: {
                        required: () => this.$t('Please-choose-a-date')
                    }
                }
            }
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from.path;
        });
    },
    beforeMount: beforeMount,
    mounted() {
        this.$validator.localize("en", this.dictionary);
        this.el = this.$refs.fab.$el;

        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

        if (this.sayfayetki.Status == true) {

            var credentials = JSON.parse(window.localStorage.getItem("credentials"));

            var params = {
                CompanyCode: credentials.SirketKodu
            };

            this.$http
                .post(auth.API_URL + "api/currency/List", params, {
                    headers: {
                        Authorization: "Bearer " + auth.getAuthHeader()
                    }
                })
                .then(
                    response => {
                        this.doviztipi = response.body;
                    },
                    response => {
                        if (response.status === 0) {
                            this.text1 = "Service Unavailable-Döviz";
                            this.snackbar = true;
                        } else {
                            this.text1 = "Service Unavailable-Döviz";
                            this.snackbar = true;
                        }
                    }
                );

        } else {

            this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

                if (sonuc == true) {

                    if (this.prevRoute != null) {
                        var url = '#' + this.prevRoute

                        window.open(url, '_self')
                    } else {
                        var url = '#/'
                        window.open(url, '_self')
                    }
                } else {

                }

            });

        }
    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
        moneyformat: function (m) {
            return helpers.moneyformat(m);
        },

        bakiyekontrol: function (m) {
            return helpers.bakiyekontrol(m);
        }
    },

    components: {
        tarihcomp: tarihcomp,
        yetkidialog,
        hatadialog,
        pnrbul,
        anatip,
        genelarama,
        referansmerkezicomp,
        cariaracomp,
        takipno
    },
    watch: {},
    methods: {
        getReportExcel() {
            if (this.$refs.formgunluksatis.validate()) {
                var bastarih = new Date(this.Rapor.KayitTarihiBasla);
                var bittarih = new Date(this.Rapor.KayitTarihiBitis);

                if (bastarih <= bittarih) {
                    this.progress = true;
                    this.load1 = false;
                    var credentials = JSON.parse(window.localStorage.getItem("credentials"));

                    var paramsExcel = {
                        PSirketNo: credentials.CoperSirketNo,
                        PCariSirket: credentials.SirketKodu,
                        PPNR_No: this.Rapor.Prm.PPNR_No,
                        PPNR_ParaBirimi: this.Rapor.Prm.PPNR_ParaBirimi,
                        PKayitTarihBas: this.Rapor.KayitTarihiBasla,
                        PKayitTarihBit: this.Rapor.KayitTarihiBitis,
                        PDonem1Bas: this.Rapor.Prm.PDonem1Bas,
                        PDonem1Bit: this.Rapor.Prm.PDonem1Bit,
                        PDonem2Bas: this.Rapor.Prm.PDonem2Bas,
                        PDonem2Bit: this.Rapor.Prm.PDonem2Bit,
                        PFatTarihBas: this.Rapor.Prm.PFatTarihBas,
                        PFatTarihBit: this.Rapor.Prm.PFatTarihBit,
                        PKomFatTarihBas: this.Rapor.Prm.PKomFatTarihBas,
                        PKomFatTarihBit: this.Rapor.Prm.PKomFatTarihBit,
                        PCariKod: null,
                        PSaticiTip: this.Rapor.Prm.PSaticiTip,
                        PSaticiKod: null,
                        PDosyaTip: this.Rapor.Prm.PDosyaTip,
                        PDosya: this.Rapor.Prm.PDosya,
                        PAcente: this.Rapor.Prm.PAcente,
                        PPNRBir: this.Rapor.Prm.PPNRBir,
                        PCariHesapGrubu: this.Rapor.Prm.PCariHesapGrubu,
                        PCariTip: this.Rapor.Prm.PCariTip,
                        PSaticiGrup: this.Rapor.Prm.PSaticiGrup,
                        PSaticiIc_Dis: this.Rapor.Prm.PSaticiIc_Dis,
                        PTurOp: null,
                        PFaturali: this.Rapor.Prm.PFaturali,
                        POpsiyon: this.Rapor.Prm.POpsiyon,
                        PAnaTip: this.Rapor.Prm.PAnaTip,
                        PCariAnaHesap: null,
                        PIptalRaporu: this.Rapor.Prm.PIptalRaporu,
                        PRezGrupID: this.Rapor.Prm.PRezGrupID,
                        PSatisGrubu: this.Rapor.Prm.PSatisGrubu,
                        PSatisGrupTip: this.Rapor.Prm.PSatisGrupTip,
                        PSaticiOdemesiHesapla: this.Rapor.Prm.PSaticiOdemesiHesapla,
                        PMasrafMerkezi: null,
                        PPNR_ParaBirimi: this.Rapor.ParaBirimi,
                        PAcenteDepartmanID: this.Rapor.Prm.PAcenteDepartmanID,
                        PPozisyonNo: this.Rapor.Prm.PPozisyonNo,
                        PSatisFaturaNo: this.Rapor.Prm.PSatisFaturaNo,
                        PMusteriOdemelilerHaric: this.Rapor.Prm.PMusteriOdemelilerHaric,
                        PReferans: this.Rapor.Prm.PReferans,
                        PSatisTip1: this.Rapor.Prm.PSatisTip1,
                        PSatisTip2: this.Rapor.Prm.PSatisTip2,
                        PSatisTip3: this.Rapor.Prm.PSatisTip3,
                        PSatisTip4: this.Rapor.Prm.PSatisTip4,
                        PGelenFatTarihBas: this.Rapor.Prm.PGelenFatTarihBas,
                        PGelenFatTarihBit: this.Rapor.Prm.PGelenFatTarihBit,
                        PProfilSablonId: this.Rapor.Prm.PProfilSablonId,
                        PKomisyonFaturali: this.Rapor.Prm.PKomisyonFaturali,
                        PGelenFaturali: this.Rapor.Prm.PGelenFaturali

                    }

                    if (this.Rapor.Prm.PCariKod != null) {
                        paramsExcel.PCariKod = this.Rapor.Prm.PCariKod.id
                    } else {
                        paramsExcel.PCariKod = this.Rapor.Prm.PCariKod
                    }

                    if (this.Rapor.Prm.PSaticiKod != null) {
                        paramsExcel.PSaticiKod = this.Rapor.Prm.PSaticiKod.kod
                    } else {
                        paramsExcel.PSaticiKod = this.Rapor.Prm.PSaticiKod
                    }

                    if (this.Rapor.Prm.PCariAnaHesap != null) {
                        paramsExcel.PCariAnaHesap = this.Rapor.Prm.PCariAnaHesap.id
                    } else {
                        paramsExcel.PCariAnaHesap = this.Rapor.Prm.PCariAnaHesap
                    }

                    if (this.Rapor.Prm.PMasrafMerkezi != null) {
                        paramsExcel.PMasrafMerkezi = this.Rapor.Prm.PMasrafMerkezi.kod
                    } else {
                        paramsExcel.PMasrafMerkezi = this.Rapor.Prm.PMasrafMerkezi
                    }

                    if (this.Rapor.Prm.PTurOp != null) {
                        paramsExcel.PTurOp = this.Rapor.Prm.PTurOp.kod
                    } else {
                        paramsExcel.PTurOp = this.Rapor.Prm.PTurOp
                    }

                    var params = {
                        Prm: paramsExcel
                    }

                    tool.http_post(this, "ExcelSatisRaporu", params).then(
                        response => {
                            if (response.body.Status == true) {
                                //   this.itemssatis = response.body.data;

                                this.progress = false;
                                this.load1 = true;
                            } else {
                                this.text1 = response.body.ErrorList[0];
                                this.snackbar = true;
                                this.progress = false;
                                this.load1 = true;
                            }
                        },
                        response => {
                            this.HataYonetimi(response, params, 'Satış Listesi Getirilemedi');
                            this.progress = false;
                            this.load1 = true;
                        }
                    );
                } else {
                    this.text1 = this.$t('start-date-cannot-greater-than-end-date')
                    this.snackbar = true;
                }
            }

        },

        pnrIptalDialog(val) {
            this.iptalDialog = true
            this.IptalNedeni = null
            this.secilenKayit = val
        },

        pnrIptal() {
            if (this.$refs.formiptal.validate()) {

                let params = {
                    IptalTipi: 1, //PNR iptalinde 1, Takip No iptalinde 2 olacak, Henüz Takip No iptal yapılmadı.
                    IptalNo: this.secilenKayit.PNR_No, //PNR No veya Takip No
                    IptalNedeni: this.IptalNedeni
                }

                tool.http_post(this, 'RezervasyonIptal', params).then(

                    response => {

                        if (response.body.Status == true) {
                            this.text1 = "PNR iptal edildi."
                            this.snackbar = true
                            this.iptalDialog = false

                            this.getList();

                        } else {
                            this.text1 = response.body.ErrorList[0]
                            this.snackbar = true
                        }

                    },

                    response => {

                        this.text1 = this.$t('An-error-has-occurred-Please-try-again')

                        this.snackbar = true

                    }

                );
            }

        },
        HataYonetimi(response, request, baslik) {
            if (response.status === 500) {
                //Internal Server Error
                this.$refs.hatadialog.open(response, request, baslik);
            } else {
                this.text1 = "Service Unavailable -" + baslik;
                this.snackbar = true;
            }
        },

        git(val) {
            if (val.TakipNo != null) {
                var url = "#/coper/vize/yeni/id?islem=get&TakipNo=" + val.TakipNo;
                window.open(url, "_target");
            } else {
                var url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val.PNR_No;
                window.open(url, "_target");
            }

            // var url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val.PNR_No;
            // window.open(url, "_target");

        },
        getList: getList,
        filtrele: filtrele,
        filtrekayit: filtrekayit,
        filtreiptal: filtreiptal
    }
};

function filtrele() {
    this.dialogfiltre = true;
}

function filtrekayit() {
    this.filtrevarmi = true;
    this.dialogfiltre = false;
    this.getList();
}

function filtreiptal() {
    this.filtrevarmi = false;
    this.dialogfiltre = false;

    this.Rapor.TakipNo = null;

    this.Rapor.Prm.PPNR_No = null;
    this.Rapor.Prm.PPNR_ParaBirimi = null
    this.Rapor.Prm.PCariKod = null
    this.Rapor.Prm.PSaticiTip = null
    this.Rapor.Prm.PSaticiKod = null
    this.Rapor.Prm.PDosyaTip = null
    this.Rapor.Prm.PDosya = null
    this.Rapor.Prm.PAcente = null
    this.Rapor.Prm.PPNRBir = null
    this.Rapor.Prm.PCariHesapGrubu = null
    this.Rapor.Prm.PCariTip = null
    this.Rapor.Prm.PSaticiGrup = null
    this.Rapor.Prm.PSaticiIc_Dis = null
    this.Rapor.Prm.PTurOp = null
    this.Rapor.Prm.PFaturali = null
    this.Rapor.Prm.POpsiyon = null
    this.Rapor.Prm.PAnaTip = null
    this.Rapor.Prm.PCariAnaHesap = null
    this.Rapor.Prm.PIptalRaporu = null
    this.Rapor.Prm.PRezGrupID = null
    this.Rapor.Prm.PSatisGrubu = null
    this.Rapor.Prm.PSatisGrupTip = null
    this.Rapor.Prm.PSaticiOdemesiHesapla = null
    this.Rapor.Prm.PMasrafMerkezi = null
    this.Rapor.Prm.PAcenteDepartmanID = null
    this.Rapor.Prm.PPozisyonNo = null
    this.Rapor.Prm.PSatisFaturaNo = null
    this.Rapor.Prm.PMusteriOdemelilerHaric = null
    this.Rapor.Prm.PReferans = null
    this.Rapor.Prm.PSatisTip1 = null
    this.Rapor.Prm.PSatisTip2 = null
    this.Rapor.Prm.PSatisTip3 = null
    this.Rapor.Prm.PSatisTip4 = null
    this.Rapor.Prm.PProfilSablonId = null
    this.Rapor.Prm.PKomisyonFaturali = null
    this.Rapor.Prm.PGelenFaturali = null

    this.getList();

}

function getList() {
    if (this.$refs.formgunluksatis.validate()) {
        var bastarih = new Date(this.Rapor.KayitTarihiBasla);
        var bittarih = new Date(this.Rapor.KayitTarihiBitis);

        if (bastarih <= bittarih) {
            this.progress = true;
            this.load1 = false;

            var credentials = JSON.parse(window.localStorage.getItem("credentials"));

            var RaporParam = {
                KayitTarihiBasla: null,
                KayitTarihiBitis: null,
                ParaBirimi: null,
                TakipNo: null,
                Prm: {}
            }

            RaporParam.KayitTarihiBasla = this.Rapor.KayitTarihiBasla
            RaporParam.KayitTarihiBitis = this.Rapor.KayitTarihiBitis
            RaporParam.ParaBirimi = this.Rapor.ParaBirimi
            RaporParam.TakipNo = this.Rapor.TakipNo

            RaporParam.Prm.PSirketNo = credentials.CoperSirketNo
            RaporParam.Prm.PCariSirket = credentials.SirketKodu
            RaporParam.Prm.PPNR_No = this.Rapor.Prm.PPNR_No
            RaporParam.Prm.PPNR_ParaBirimi = this.Rapor.Prm.PPNR_ParaBirimi
            RaporParam.Prm.PKayitTarihBas = this.Rapor.Prm.PKayitTarihBas
            RaporParam.Prm.PKayitTarihBit = this.Rapor.Prm.PKayitTarihBit
            RaporParam.Prm.PDonem1Bas = this.Rapor.Prm.PDonem1Bas
            RaporParam.Prm.PDonem1Bit = this.Rapor.Prm.PDonem1Bit
            RaporParam.Prm.PDonem2Bas = this.Rapor.Prm.PDonem2Bas
            RaporParam.Prm.PDonem2Bit = this.Rapor.Prm.PDonem2Bit
            RaporParam.Prm.PFatTarihBas = this.Rapor.Prm.PFatTarihBas
            RaporParam.Prm.PFatTarihBit = this.Rapor.Prm.PFatTarihBit
            RaporParam.Prm.PKomFatTarihBas = this.Rapor.Prm.PKomFatTarihBas
            RaporParam.Prm.PKomFatTarihBit = this.Rapor.Prm.PKomFatTarihBit
            RaporParam.Prm.PSaticiTip = this.Rapor.Prm.PSaticiTip
            RaporParam.Prm.PDosyaTip = this.Rapor.Prm.PDosyaTip
            RaporParam.Prm.PDosya = this.Rapor.Prm.PDosya
            RaporParam.Prm.PAcente = this.Rapor.Prm.PAcente
            RaporParam.Prm.PPNRBir = this.Rapor.Prm.PPNRBir
            RaporParam.Prm.PCariHesapGrubu = this.Rapor.Prm.PCariHesapGrubu
            RaporParam.Prm.PCariTip = this.Rapor.Prm.PCariTip
            RaporParam.Prm.PSaticiGrup = this.Rapor.Prm.PSaticiGrup
            RaporParam.Prm.PSaticiIc_Dis = this.Rapor.Prm.PSaticiIc_Dis
            RaporParam.Prm.PFaturali = this.Rapor.Prm.PFaturali
            RaporParam.Prm.POpsiyon = this.Rapor.Prm.POpsiyon
            RaporParam.Prm.PAnaTip = this.Rapor.Prm.PAnaTip
            RaporParam.Prm.PIptalRaporu = this.Rapor.Prm.PIptalRaporu
            RaporParam.Prm.PRezGrupID = this.Rapor.Prm.PRezGrupID
            RaporParam.Prm.PSatisGrubu = this.Rapor.Prm.PSatisGrubu
            RaporParam.Prm.PSatisGrupTip = this.Rapor.Prm.PSatisGrupTip
            RaporParam.Prm.PSaticiOdemesiHesapla = this.Rapor.Prm.PSaticiOdemesiHesapla
            RaporParam.Prm.PAcenteDepartmanID = this.Rapor.Prm.PAcenteDepartmanID
            RaporParam.Prm.PPozisyonNo = this.Rapor.Prm.PPozisyonNo
            RaporParam.Prm.PSatisFaturaNo = this.Rapor.Prm.PSatisFaturaNo
            RaporParam.Prm.PMusteriOdemelilerHaric = this.Rapor.Prm.PMusteriOdemelilerHaric
            RaporParam.Prm.PReferans = this.Rapor.Prm.PReferans
            RaporParam.Prm.PSatisTip1 = this.Rapor.Prm.PSatisTip1
            RaporParam.Prm.PSatisTip2 = this.Rapor.Prm.PSatisTip2
            RaporParam.Prm.PSatisTip3 = this.Rapor.Prm.PSatisTip3
            RaporParam.Prm.PSatisTip4 = this.Rapor.Prm.PSatisTip4
            RaporParam.Prm.PGelenFatTarihBas = this.Rapor.Prm.PGelenFatTarihBas
            RaporParam.Prm.PGelenFatTarihBit = this.Rapor.Prm.PGelenFatTarihBit
            RaporParam.Prm.PProfilSablonId = this.Rapor.Prm.PProfilSablonId
            RaporParam.Prm.PKomisyonFaturali = this.Rapor.Prm.PKomisyonFaturali
            RaporParam.Prm.PGelenFaturali = this.Rapor.Prm.PGelenFaturali
            if (this.Rapor.Prm.PCariKod != null) {
                RaporParam.Prm.PCariKod = this.Rapor.Prm.PCariKod
            } else {
                RaporParam.Prm.PCariKod = this.Rapor.Prm.PCariKod
            }

            if (this.Rapor.Prm.PSaticiKod != null) {
                RaporParam.Prm.PSaticiKod = this.Rapor.Prm.PSaticiKod.kod
            } else {
                RaporParam.Prm.PSaticiKod = this.Rapor.Prm.PSaticiKod
            }

            if (this.Rapor.Prm.PCariAnaHesap != null) {
                RaporParam.Prm.PCariAnaHesap = this.Rapor.Prm.PCariAnaHesap
            } else {
                RaporParam.Prm.PCariAnaHesap = this.Rapor.Prm.PCariAnaHesap
            }

            if (this.Rapor.Prm.PMasrafMerkezi != null) {
                RaporParam.Prm.PMasrafMerkezi = this.Rapor.Prm.PMasrafMerkezi.kod
            } else {
                RaporParam.Prm.PMasrafMerkezi = this.Rapor.Prm.PMasrafMerkezi
            }

            if (this.Rapor.Prm.PTurOp != null) {
                RaporParam.Prm.PTurOp = this.Rapor.Prm.PTurOp.kod
            } else {
                RaporParam.Prm.PTurOp = this.Rapor.Prm.PTurOp
            }

            var params = RaporParam

            tool.http_post(this, "GunlukSatisList", params).then(
                response => {
                    if (response.body.Status == true) {
                        this.itemssatis = response.body.data;

                        this.progress = false;
                        this.load1 = true;
                    } else {
                        this.text1 = response.body.ErrorList[0];
                        this.snackbar = true;
                        this.progress = false;
                        this.load1 = true;
                    }
                },
                response => {
                    this.HataYonetimi(response, params, 'Satış Listesi Getirilemedi');
                    this.progress = false;
                    this.load1 = true;
                }
            );
        } else {
            this.text1 = this.$t('start-date-cannot-greater-than-end-date')
            this.snackbar = true;
        }
    }
}

function beforeMount() {}
</script>

<style>
</style>
